export const PRICE_MODE = {
  BASE: "base",
  FEES: "fees",
  FEES_AND_TAXES: "fees_and_taxes"
} as const;

export type PriceMode = (typeof PRICE_MODE)[keyof typeof PRICE_MODE];
